import { Injectable, EventEmitter } from '@angular/core';
import * as io from 'socket.io-client';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';

@Injectable()
export class SocketService {
    public socket;
    public messageProgress: EventEmitter<any> = new EventEmitter();
    public messageReceived: EventEmitter<any> = new EventEmitter();
    public replyReceived: EventEmitter<any> = new EventEmitter();
    public initUser: EventEmitter<any> = new EventEmitter();

    constructor() { }

    setupSocket() {
        const token = localStorage.getItem('token');
        this.socket = io.connect(environment.apiUrl ? environment.apiUrl : '/');
        this.socket.on('connect', () => {
            console.log('connected');
            this.initUser.emit();
            this.socket
                .emit('authenticate', { token })
                .on('authenticated', () => {
                    // do other things
                    console.log('authenticated');
                })
                .on('init', (data) => {
                    // do other things
                    console.log('init');
                })
                .on('unauthorized', (msg) => {
                    this.setupSocket();
                    // throw new Error(msg.data.type);
                    console.log('unauthorized');
                })
        });
        
        const reconnect = () => {
            console.log('Attempting to reconnect...');
            this.socket.connect();
        };

        this.socket.on('disconnect', () => {
            console.log('Disconnected');
            setTimeout(reconnect, 5000); // Attempt to reconnect after 5 seconds
        });

        this.socket.on('message-progress', (data: string) => {
            // console.log('message-progress', data);
            this.messageProgress.emit(data);
        });

        this.socket.on('message-progress-object', (data: string) => {
            // this.messageProgress.emit(data);
        });

        this.socket.on('message-received', (data: string) => {
            // console.log('message-received', data);
            this.messageReceived.emit(data);
        });

        this.socket.on('reply-received', (data: string) => {
            // console.log('reply-received', data);
            this.replyReceived.emit(data);
        });
    }

    getActivities() {
        return new Observable((observer) => {
            this.socket.emit('activities');
            this.socket.on('activities', (data: string) => {
                observer.next(data);
            });
        });
    }

    getActivityCounts() {
        return new Observable((observer) => {
            this.socket.emit('activity-counts');
            this.socket.on('activity-counts', (data: string) => {
                observer.next(data);
            });
        });
    }

    checkUserLogin() {
        return new Observable((observer) => {
            this.socket.emit('account-check');
            this.socket.on('account-check', (data: string) => {
                observer.next(data);
            });
        });
    }

    emailListener() {
        return new Observable((observer) => {
            // this.socket.emit('account-check');
            this.socket.on('email-received', (data: string) => {
                observer.next(data);
            });
        });
    }

    emailsListener() {
        return new Observable((observer) => {
            // this.socket.emit('account-check');
            this.socket.on('emails-received', (data: string) => {
                observer.next(data);
            });
        });
    }

    init() {
        return new Observable((observer) => {
            this.socket.on('init', (data: string) => {
                observer.next(data);
            });
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/socket.service.ts